import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import ProjectsSection from "@/components/ProjectsSection";
import ContactSection from "@/components/ContactSection";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import { Linkedin } from "lucide-react";

const Index = () => {
  useSmoothScroll();
  useVisitorTracking();
  return (
    <div className="min-h-screen">
      <header>
        <Navigation />
      </header>
      
      <main>
        <Hero />
        <ProjectsSection />
        <ContactSection />
      </main>
      
      {/* Footer */}
      <footer className="bg-card py-8 border-t">
        <div className="container mx-auto px-4 text-center">
          <p className="text-muted-foreground">© 2025 Savinien Gicquel - Chef de Projet Digital. Tous droits réservés.</p>
          <div className="mt-4">
            <a 
              href="https://www.linkedin.com/in/saviniengicquel/" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Profil LinkedIn de Savinien Gicquel"
              className="inline-flex items-center justify-center hover:opacity-70 transition-opacity"
            >
              <Linkedin className="h-6 w-6 text-black" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Index;